import { FormikErrors, FormikTouched } from 'formik';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook that provides better support for i18n forms
 */
const useI18nForm = ({
  errors,
  touched,
  setFieldTouched,
}: {
  errors: FormikErrors<any>;
  touched: FormikTouched<any>;
  setFieldTouched: any;
}): void => {
  const { i18n } = useTranslation();
  const prevLanguageRef = useRef(i18n.language);
  const invalidFields = Object.keys(errors);

  // When the language changes, we need to force the re-validation of the form to translate the error messages.
  useEffect(() => {
    if (prevLanguageRef.current !== i18n.language) {
      Object.keys(errors).forEach((fieldName) => {
        if (Object.keys(touched).includes(fieldName)) {
          setFieldTouched(fieldName);
        }
      });
    }
    prevLanguageRef.current = i18n.language;
  }, [i18n.language, invalidFields, errors, touched, setFieldTouched]);
};

export default useI18nForm;
